import { Component } from 'react';
import { RadioBox } from './radiobox';
import { FormError } from './form-errors';
import { MontantInput } from './montant-input';
import { MontantsDetailles } from './details-montant-input';
import analytics, { FIELD_IDS, CONDITIONAL_IDS } from '../../services/analytics';

const STEP_NUMBER = 6;

class Questionnaire extends Component {
	constructor(props) {
		super(props);

		// Récupérer le field tracker pour le tracking granulaire des champs
		this.fieldTracker = analytics.getFieldTracker();
		this.state = {
			steps: 4, // 1: pensionAlimentaire, 2: permis, 3: creation, 4: velo
			step: 1,
			hasPensionAlimentaire: false,
			pensionAlimentaire: {
				value: {},

			},
			pensionDetails: false,
			permisDeConduire: false,
			lieuxSolidaire: false,
			creationEntreprise: false,
			aideAchatVelo: false,
			errors: [],
			rfr: 0,
		};

		/* Initialisation pension alimentaire */

		this.state.pensionAlimentaire.value = '';
		/*aides velo */

		this.state.veloPrice = 0;
		this.state.veloType = false;


	}


	updateVeloPrice = (event) => {
		// Field tracking
		this.fieldTracker.onFieldChange(STEP_NUMBER, FIELD_IDS.STEP_FINAL_QUESTIONS.prix_velo, event.target.value);
		this.setState({ veloPrice: event.target.value });
	}

	updateVeloType = (event) => {
		// Field tracking
		this.fieldTracker.onFieldFocus(STEP_NUMBER, FIELD_IDS.STEP_FINAL_QUESTIONS.type_velo, this.state.veloType);
		this.fieldTracker.onFieldChange(STEP_NUMBER, FIELD_IDS.STEP_FINAL_QUESTIONS.type_velo, event.target.value);
		this.fieldTracker.onFieldBlur(STEP_NUMBER, FIELD_IDS.STEP_FINAL_QUESTIONS.type_velo, event.target.value);
		this.setState({ veloType: event.target.value });
	}
	updateRFR = (event) => {
		this.setState({ rfr: event.target.value });

	}

	checkInputErrors = async () => {
		const STEP_NUMBER = 6;
		let errors = []
		if (this.state.step === 1
			&& (isNaN(this.state.pensionAlimentaire.value) || this.state.pensionAlimentaire.value === "")
			&& this.state.hasPensionAlimentaire
			&& !this.state.pensionDetails
		) {
			errors.push("Veuillez saisir un montant valide pour la pension alimentaire.");
			analytics.trackValidationError(STEP_NUMBER, 'ALIMONY_AMOUNT_REQUIRED', 'pensionAlimentaire');
		}
		this.setState({ errors: errors });
	}

	nextStep = (e) => {
		if (this.state.errors.length > 0) {
			return false;
		}
		let anchor = document.getElementById('anchor');
		const yOffset = -80;
		const y = anchor.getBoundingClientRect().top + window.pageYOffset + yOffset;
		window.scrollTo({ top: y, behavior: 'smooth' });

		if (this.state.step + 1 > this.state.steps) {
			var data = {
				"demandeur": {
					//permis
					permis_de_conduire: this.state.permisDeConduire,
					//lieux solidaire
					afficherLieuxSolidaire: this.state.lieuxSolidaire,
					//creation Entreprise
					creationEntreprise: this.state.creationEntreprise,
					typeVelo: this.state.veloType,
					prixVelo: this.state.veloPrice,
					rfrParPart: this.state.rfr,
				},
				"terminer": true,
			};

			if (this.state.hasPensionAlimentaire) {

				if (this.state.pensionDetails === false) {
					data.demandeur.pensions_alimentaires_versees_individu = {};
					let curMonth = new Date().getMonth();
					let curYear = new Date().getFullYear();

					let tarYear = curYear - 1;
					while (curYear >= tarYear) {
						let curDate = curYear + '-' + ('0' + (curMonth + 1)).slice(-2);
						data.demandeur.pensions_alimentaires_versees_individu[curDate] = this.state.pensionAlimentaire.value;
						curMonth -= 1;

						if (curMonth < 0) {
							curMonth = 11;
							curYear -= 1;
						}
					}

				} else {
					data.demandeur.pensions_alimentaires_versees_individu = this.state.pensionAlimentaire.value;
				}
			}

			data.demandeur.typeVelo = this.state.veloType;
			data.demandeur.prixVelo = this.state.veloPrice;

			this.props.validateStep(data);
		}


		this.setState(({ step }) => {
			return { step: step + 1 };
		});
	}

	switchRadio = (newValue, modelName) => {
		// Field tracking - map modelName to FIELD_IDS
		const fieldIdMap = {
			'hasPensionAlimentaire': FIELD_IDS.STEP_FINAL_QUESTIONS.pension_alimentaire,
			'permisDeConduire': FIELD_IDS.STEP_FINAL_QUESTIONS.aide_permis,
			'creationEntreprise': FIELD_IDS.STEP_FINAL_QUESTIONS.creation_entreprise,
			'aideAchatVelo': FIELD_IDS.STEP_FINAL_QUESTIONS.aide_velo,
		};
		const fieldId = fieldIdMap[modelName] || `FIELD_${modelName.toUpperCase()}`;
		this.fieldTracker.onFieldFocus(STEP_NUMBER, fieldId, this.state[modelName]);
		this.fieldTracker.onFieldChange(STEP_NUMBER, fieldId, newValue);
		this.fieldTracker.onFieldBlur(STEP_NUMBER, fieldId, newValue);

		// Track conditional sections
		if (modelName === 'hasPensionAlimentaire' && (newValue === true || newValue === 'true')) {
			analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.ALIMONY_AMOUNT, 'hasPensionAlimentaire');
		}
		if (modelName === 'aideAchatVelo' && (newValue === true || newValue === 'true')) {
			analytics.trackConditionalShown(STEP_NUMBER, CONDITIONAL_IDS.BIKE_DETAILS, 'aideAchatVelo');
		}

		newValue = JSON.parse(newValue);
		this.setState(() => {
			var newState = new Object({});
			newState[modelName] = newValue;
			return newState;
		});
	}

	switchDetails = (e) => (this.setState(({ pensionDetails }) => {
		pensionDetails = !pensionDetails;
		return { pensionDetails: pensionDetails }
	}))

	capturePensionAlimentaire = (montant) => {
		this.setState(({ pensionAlimentaire }) => {
			pensionAlimentaire.value = montant;
			return { pensionAlimentaire: pensionAlimentaire };
		});
	}

	capturePensionDetailler = (montants) => {
		this.setState(({ pensionAlimentaire, pensionDetails }) => {
			pensionAlimentaire.value = montants;
			pensionDetails = true;
			return { pensionAlimentaire: pensionAlimentaire };
		});
	}
	//
	pensionAlimentaire = () => {
		return <div className="pension-alimentaire">
			<div className="left-side">
				<RadioBox name="pensionAlimentaire"
					options={{ "Oui": true, "Non": false }}
					handler={this.switchRadio}
					modelName="hasPensionAlimentaire"
					defaultValue={this.state.hasPensionAlimentaire}

				><h3>Vous ou votre conjoint·e actuel·le avez-vous versé des pensions alimentaires depuis décembre 2021 ?</h3></RadioBox>
			</div>
			<div className="right-side zone-pa">
				{(this.state.hasPensionAlimentaire) ?
					<div className="saisi-montant">
						<div className="ressource-label">Pensions alimentaires</div>
						{(!this.state.pensionDetails) ?
							<MontantInput name="pensionAlimentaire"
								model={this.state.pensionAlimentaire.value}
								modelName="pensionAlimentaire"
								handler={this.capturePensionAlimentaire}
							>Montant versé chaque mois</MontantInput>
							: <MontantsDetailles name="pensionAlimentaire"
								handler={this.capturePensionDetailler}
							></MontantsDetailles>
						}
						<small className="detail-button"
							onClick={this.switchDetails}
						>
							{(this.state.pensionDetails) ?
								'Montant fixe perçu chaque mois'
								: 'détaillez les montants sur les 12 derniers mois'}
						</small>
					</div>
					: ""
				}
			</div>
		</div>;
	}

	permisDeConduire = () => {
		return <div className="question">
			<RadioBox
				name="permisDeConduire"
				options={{ "Oui": true, "Non": false }}
				defaultValue={this.state.permisDeConduire}
				modelName="permisDeConduire"
				handler={this.switchRadio}
			><h3>Souhaitez-vous connaître les aides financières au permis de conduire ?</h3></RadioBox>
		</div>;
	}

	previous = () => {
		this.props.previousStep();
	}

	restart = () => {
		this.props.restart();
	}

	creationEntreprise = () => {
		return <div className="question">
			<RadioBox
				name="creationEntreprise"
				options={{ "Oui": true, "Non": false }}
				defaultValue={this.state.creationEntreprise}
				modelName="creationEntreprise"
				handler={this.switchRadio}
			><h3>Souhaitez-vous créer ou reprendre une entreprise ?</h3></RadioBox>
		</div>;
	}

	aideAchatVelo = () => {


		return <div className="question">
			<RadioBox
				name="aideAchatVelo"
				options={{ "Oui": true, "Non": false }}
				defaultValue={this.state.aideAchatVelo}
				modelName="aideAchatVelo"
				handler={this.switchRadio}
			><h3>Souhaitez-vous connaître les aides financières pour l'achat d'un velo ?</h3></RadioBox>
			<div className={this.state.aideAchatVelo ? "visible" : "hidden"}>

				<div className="question sub-question">
					<h3>Prix du vélo</h3>
					<div className="input-with-euro">
						<input type="number" placeholder="Prix du vélo en euros" onChange={this.updateVeloPrice} />
						<span className="euroSign">€</span>
					</div>
				</div>

				<div className="question sub-question">
					<h3>Type de vélo</h3>
					<select onChange={this.updateVeloType} >
						<option value="">Choisir le type de vélo</option>
						<option value="électrique">Electrique</option>
						<option value="mécanique simple">Mécanique simple</option>
						<option value="cargo" >Cargo</option>
						<option value="cargo électrique" >Cargo Electrique</option>
						<option value="pliant" >Pliant</option>
						<option value="pliant électrique" >Pliant electrique</option>
					</select>
				</div>
			</div>
		</div>;
	}
	getQuestion() {
		if (this.state.step === 1) {
			return this.pensionAlimentaire();
		} else if (this.state.step === 2) {
			return this.permisDeConduire();
		} else if (this.state.step === 3) {
			return this.creationEntreprise();
		} else if (this.state.step === 4) {
			return this.aideAchatVelo();
		}
	}
	render() {


		return <>
			<div className="step-inner-container avant-de-terminer">
				<p className="step-title"><strong>Avant de terminer</strong></p>
				{this.getQuestion()}
				<FormError errors={this.state.errors} />
				<button onClick={() => (this.checkInputErrors().then(() => this.nextStep()))}> Valider </button>
				<div className="button-container previous">
					<button onClick={this.restart}> Recommencer </button>
				</div>
			</div>
		</>;
	}
}

export default Questionnaire;
